import React from 'react';
import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';

const useStyles = jss.makeStyles((theme) => ({
  titleContainer: {
    padding: 24,
    paddingBottom: 0,
  },
  contentContainer: {
    padding: '24px !important',
    paddingBottom: '0px !important',
  },
  actionsContainer: {
    padding: 24,
    justifyContent: 'flex-start',
  },
}));

type BaseDialogProps = {
  isVisible: boolean;
  onClose?: Function;
  Title?: Function;
  Content?: Function;
  Actions?: Function;
};

const BaseDialog = ({
  isVisible = false,
  onClose = undefined,
  Title = () => null,
  Content = () => null,
  Actions = () => null,
}: BaseDialogProps) => {
  const styles = useStyles();

  const onClickClose = (e) => {
    e.preventDefault();

    if (onClose) onClose();
  };

  // @ts-ignore
  return (
    <mui.Dialog
      maxWidth={false}
      style={{ width: 'auto' }}
      onBackdropClick={onClickClose}
      onClose={onClickClose}
      open={isVisible}
      data-testid="base-dialog"
      PaperProps={{
        style: {
          backgroundColor: '#fff',
        },
      }}
    >
      <mui.DialogTitle className={styles.titleContainer} data-testid="dialog-title-section">
        {/*@ts-ignore @TODO Epic WT-21600*/}
        <Title />
      </mui.DialogTitle>

      {Content && (
        <mui.DialogContent className={styles.contentContainer} data-testid="dialog-content">
          {/*@ts-ignore @TODO Epic WT-21600*/}
          <Content />
        </mui.DialogContent>
      )}

      <mui.DialogActions className={styles.actionsContainer} data-testid="dialog-actions">
        {/*@ts-ignore @TODO Epic WT-21600*/}
        <Actions />
      </mui.DialogActions>
    </mui.Dialog>
  );
};

export default BaseDialog;
